import src from "IMAGE";
export default { src, width: 91, height: 91, blurWidth: 0, blurHeight: 0};
